module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-bottom.1cc7a8af.svg";